<template>
  <div id="aba-dados-principais">
    <card v-if="loading">
      <small-loading :loading="true"></small-loading>
    </card>

    <template v-else>
      <card :titulo="tipoLivro">
        <card-content>
          <p><span class="font-weight-500">Situação: </span><span>{{ statusName }}</span></p>
          <p><span class="font-weight-500">Data da Lavratura: </span><span>{{lavratura | data}}</span></p>
        </card-content>
      </card>

      <informacoes-livro :tipo-registro="tipoRegistro" :ficha="ficha.id" :is-protocolo-especial-notas="true" />

      <card titulo="Envolvidos" v-if="envolvidos && envolvidos.length">

        <table class="table table-striped card-table table-vcenter">
          <thead>
            <tr>
              <th class="pl-2">PESSOA</th>
              <th>DOCUMENTO</th>
              <th class="text-right pr-2">PAPEL</th>
              <th class="text-right pr-2">CATEGORIA</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(envolvido, index) in envolvidos" :key="index+envolvido.indicadorPessoalVersaoId">
              <td class="pl-2"><a href class="mb-1 pointer" @click.prevent="detalhes(envolvido.indicadorPessoalVersaoId)">{{envolvido.nome}}</a></td>
              <td class="nowrap">{{envolvido.documento}}</td>
              <td class="nowrap text-right pr-2">{{nomePapel(envolvido.papel)}}</td>
              <td class="nowrap text-right pr-2">{{ categoriaLabel(envolvido.categoriaenvolvido) }}</td>
            </tr>
          </tbody>
        </table>
      </card>
    </template>
  </div>
</template>

<script>

import SmallLoading from "@/components/SmallLoading.vue";
import Card from "@/components/Layout/components/Card.vue";
import InformacoesLivro from "@/components/IndicadorGeneric/Detalhes/InformacoesLivro.vue";
import CardContent from "@/components/Layout/components/CardContent.vue";
import RegistroNotasBusiness from "@/business/indicadores/RegistroNotasBusiness";
import IndicadorBusiness from "@/business/indicadores/IndicadorBusiness";
import FrontBusiness from "@/business/FrontBusiness";
import DetalhesIndicadorPessoal from "@/components/IndicadorPessoal/Detalhes/DetalhesIndicadorPessoal.vue";
import DominioBusiness from "@/business/protocolo/DominioBusiness";

export default {

  name: "Dados",
  components: {InformacoesLivro, CardContent, Card, SmallLoading},
  props: {
    id: String,
  },

  data() {
    return {
      documentos: [],
      envolvidos : [],
      ficha : [],
      loading : true,
      status: [],
      tipoRegistroAnterior: '',
    }
  },

  async mounted() {
    this.loading = true;
    
    try {
      const [data, envolvidos] = await Promise.all([
        RegistroNotasBusiness.getById(this.id),
        RegistroNotasBusiness.getEnvolvidos(this.id),
      ]);
      this.ficha = data;
      this.envolvidos = envolvidos;
      this.status = await RegistroNotasBusiness.getStatusPorDominio(this.ficha.livro);
      if (!this.status.find(s => s.id === 'PENDENTE')) {
        this.status.push({id: 'PENDENTE', nome: 'Pendente'});
      }
    } catch (err) {
      this.envolvidos = [];
    } finally {
      this.loading = false;
    }
  },

  methods: {
    nomePapel(papel){ return FrontBusiness.getLabel(papel, this.$root.papeis) },

    categoriaLabel(valor) {
      const labels = {
        OUTORGANTE: 'Outorgante',
        OUTORGADO: 'Outorgado',
        INTERVENIENTE: 'Interveniente',
      };
      return labels[valor] || '';
    },

    detalhes(versao) {
      FrontBusiness.openModal(DetalhesIndicadorPessoal, {versao});
    }
  },

  computed: {
    tipoRegistro(){
      return RegistroNotasBusiness.getTipos().find(t => t.id === this.ficha.livro)?.nome;
    },

    tipoLivro() {
      return DominioBusiness.getDominio(this.ficha.livro)?.nome;
    },

    lavratura(){
     return this.ficha.abertura;
    },

    statusName() {
      const statusExibido = IndicadorBusiness.getStatusExibido(this.ficha);
      return this.status.find(s => s.id === statusExibido)?.nome || RegistroNotasBusiness.formatarNomeStatus(statusExibido);
    }
  }
}
</script>
